import { AnaliseProjetoAnalise } from "./AnaliseProjetoAnalise";

export default AnaliseProjetoAnalise;